import { render, staticRenderFns } from "./NationalitySetting.vue?vue&type=template&id=0bd103c2"
import script from "./NationalitySetting.vue?vue&type=script&lang=js"
export * from "./NationalitySetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports